import { useCallback, useMemo } from 'react';

// Context
import { useBasket, useBasketProduct } from '.';
import { useBranchSelection } from '/utilities/branch-selection';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';

export const useBasketProductControls = (product) => {
	const { initialized, setProductQuantity } = useBasket();
	const { tableNumber } = useBranchSelection();
	const { openModal } = useModals();
	const basketProduct = useBasketProduct(product?.id);

	const canAdd = useMemo(() => product?.status === 1, [product]);

	const quantity = useMemo(
		() => (canAdd ? (basketProduct?.quantity ?? 0) : 0),
		[basketProduct, canAdd]
	);

	const increaseQuantity = useCallback(() => {
		if (product) {
			if (tableNumber) {
				setProductQuantity(product, quantity + 1);
			} else {
				openModal('tableNumberConfirmation', {
					onConfirm: () => {
						setProductQuantity(product, quantity + 1);
					},
				});
			}
		}
	}, [quantity, product]);

	const decreaseQuantity = useCallback(
		(confirmOnRemove) => {
			if (product && quantity > 0) {
				new Promise((resolve, reject) => {
					if (quantity === 1 && confirmOnRemove) {
						openModal('confirm', {
							title: 'Sepet değişikliği',
							message: 'Ürünü sepetinden çıkarmak istediğine emin misin?',
							onConfirm: resolve,
							onReject: reject,
						});
					} else {
						resolve();
					}
				})
					.then(() => {
						setProductQuantity(product, quantity - 1);
					})
					.catch(() => {});
			}
		},
		[quantity, product]
	);

	const [canIncreaseQuantity, canDecreaseQuantity] = useMemo(
		() => [initialized, initialized && quantity > 0],
		[quantity, initialized]
	);

	return {
		quantity,
		canAdd,
		increaseQuantity,
		decreaseQuantity,
		canIncreaseQuantity,
		canDecreaseQuantity,
	};
};
